module.exports = __webpack_public_path__ + "static/img/Jayden-Brailey.bea8754.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jayden-Brailey.jpg
// module id = JFNx
// module chunks = 0